import request from '@/util/request';
import qs from 'qs';

export const getRefundList = (params, options) =>
  request.get('/api/v4ward/pay/payRefund/page', Object.assign({}, options, { params }));

export const getList = (params, options) =>
  request.get('/api/v4ward/pay/payRefund/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/pay/payRefund/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/pay/payRefund/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/pay/payRefund/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/pay/payRefund/submit', params, options);

export const apply = (params, options) =>
  request.post('/api/v4ward/pay/payRefund/apply', params, options);

export const refund = (params, options) =>
  request.post('/api/v4ward/pay/payRefund/refund', params, options);
